module.exports = __webpack_public_path__ + "static/media/note.244c9174.png";